import { useEffect, useState, useCallback } from 'react';
import { getActiveRentals, type Booking } from '../../api';

const TTL_MS = 30_000;
let cachedPromise: Promise<Booking[]> | null = null;
let cachedAt = 0;
const listeners = new Set<() => void>();

function fetchOnce(): Promise<Booking[]> {
  const now = Date.now();
  if (!cachedPromise || now - cachedAt > TTL_MS) {
    // Hent op til 50 — widgets sorterer/filterer client-side
    cachedPromise = getActiveRentals(50, 'ends');
    cachedAt = now;
  }
  return cachedPromise;
}

function invalidate() {
  cachedPromise = null;
  cachedAt = 0;
  for (const fn of listeners) fn();
}

/**
 * Delt hook for igangværende udlejninger. Caches 30 sek så Næste afleveringer
 * og Igangværende udlejninger-widgets kun fetcher én gang.
 */
export function useActiveRentals() {
  const [data, setData] = useState<Booking[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    fetchOnce()
      .then(d => { setData(d); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, []);

  useEffect(() => {
    load();
    const onUpdate = () => load();
    listeners.add(onUpdate);
    return () => { listeners.delete(onUpdate); };
  }, [load]);

  return { data, loading, error, refresh: invalidate };
}
